import React, { Component } from "react";
import { Card, Row, Col } from "antd";
import { Fragment } from "react";
import "./ClaimsDetail.css";

export default class PaymentDetailsTable extends Component {
  render() {
    return (
      <Fragment>
        <Row className="py-2 services-header">
          <Col span={1} className="pt-2 pl-2">
            #
          </Col>
          <Col span={1} className="pt-2">
            Code
          </Col>
          <Col span={2} className="pt-2">
            Dos From
          </Col>
          <Col span={2} className="pt-2">
            Dos To
          </Col>
          <Col span={1} className="pt-2">
            P.O.S.
          </Col>
          {/* <Col span={3} className="px-3" style={{textAlign: "center"}}>
            <span>Modifier</span>
            <Row>
              <Col span={6} className="">
                A
              </Col>
              <Col span={6} className="">
                B
              </Col>
              <Col span={6} className="">
                C
              </Col>
              <Col span={6}>D</Col>
            </Row>
          </Col> */}

          <Col span={3} className="px-3" style={{textAlign: "center"}}>
            <span>Diagnosis Points</span>
            <Row justify="center">
              <Col span={6} className="">
                A
              </Col>
              <Col span={6} className="">
                B
              </Col>
              <Col span={6} className="">
                C
              </Col>
              <Col span={6}>D</Col>
            </Row>
          </Col>
          <Col span={1} className="pt-2">
            Unit
          </Col>
          <Col span={2} className="pt-2">
            Unit Count
          </Col>
          <Col span={1} className="pt-2">
            Copay
          </Col>
          <Col span={1} className="pt-2">
            Coins
          </Col>
          <Col span={2} className="pt-2">
            Total Charges
          </Col>
          <Col span={2} className="claimsServiceLines">
            Adjudication Status
          </Col> 
          <Col span={2} className="pt-2">
            Status
          </Col>
          <Col span={2} className="pt-2">
            Action
          </Col>
        </Row>
      </Fragment>
    );
  }
}
